import { render } from "./BotonContabilidadEmbargoGobernacionComponent.vue?vue&type=template&id=9e8ec3a4"
import script from "./BotonContabilidadEmbargoGobernacionComponent.vue?vue&type=script&lang=js"
export * from "./BotonContabilidadEmbargoGobernacionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__